// extracted by mini-css-extract-plugin
export default {"skeleton":"EducaFileGrid_skeleton__g-us6","pagination":"EducaFileGrid_pagination__2FxdT","totalHint":"EducaFileGrid_totalHint__gn49V"};